import { Outlet } from 'react-router-dom';
import React, { useMemo, useState, useEffect } from "react";
import NavBar from './Components/NavBar/NavBar';
import { NavUIProvider } from "./Components/Context/NavUIContext";
import 'aos/dist/aos.css';
import { Col } from "react-bootstrap";
import { checkAuth } from './Components/Helpers/ProtectedRoute';

const NavBarChild = React.memo(({ isAuthenticated, setIsAuthenticated, toggleLanguage, l, setLanguage, language }) => {
  const states = useMemo(() => ({ isAuthenticated, setIsAuthenticated, toggleLanguage, l, setLanguage, language }), [isAuthenticated, setIsAuthenticated, toggleLanguage, l, setLanguage, language]);
  return <NavBar states={states} />;
});

const Layout = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const useLanguage = () => {
    const [language, _setLanguage] = useState(() => {
      return localStorage.getItem("language") || "swe";
    });

    const setLanguage = (lang) => {
      localStorage.setItem("language", lang);
      _setLanguage(lang);
    };

    const toggleLanguage = () => {
      const newLang = language === "swe" ? "eng" : "swe";
      setLanguage(newLang);
    }

    return [language, toggleLanguage, setLanguage];
  }

  const [language, toggleLanguage, setLanguage] = useLanguage();

  useEffect(() => {
    const auth = async () => {
      const isAuthedRes = await checkAuth();
      setIsAuthenticated(isAuthedRes.isAuthenticated);
    };
    auth();
  }, []);

  const l = (swedishText, englishText) => {
    if (language === "swe") {
      return swedishText
    };
    return englishText;
  };

  const languageAuthStates = {
    isAuthenticated,
    setIsAuthenticated,
    toggleLanguage,
    language,
    setLanguage,
    l
  };

  return (
    <>
      <div
        className="d-flex justify-content-center m-0 p-0 position-fixed"
        style={{ zIndex: 10002, width: "100vw", overflowY: "scroll", maxHeight: "100vh" }}
      >
        <Col xxl={8} xl={10} lg={10} md={10} xs={11} className="m-0 p-0 d-flex flex-column min-vh-100">
          <NavUIProvider>
            <NavBarChild {...languageAuthStates} />
          </NavUIProvider>
          <main className="flex-grow-1">
            <Outlet context={{ isAuthenticated, setIsAuthenticated, toggleLanguage, l, setLanguage, language }} />
          </main>
          <footer className="bg-light text-center py-3 mt-auto">
            <small>&copy; {new Date().getFullYear()}&nbsp;
              Introteknik AB<br></br>
              Kungsgatan 87 - 632 21 Eskilstuna<br></br>
              {l('Hemsida utvecklad av Forget-IT', 'Website developed by Forget-IT')}&copy;
            </small>
          </footer>
        </Col>
      </div>
    </>
  );
};

export default Layout;
